import { render, staticRenderFns } from "./finalDecision.vue?vue&type=template&id=40b40762&scoped=true&"
import script from "./finalDecision.vue?vue&type=script&lang=js&"
export * from "./finalDecision.vue?vue&type=script&lang=js&"
import style0 from "./finalDecision.vue?vue&type=style&index=0&id=40b40762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b40762",
  null
  
)

export default component.exports